export default "__VITE_ASSET__c3b073ca__"